<template>
  <button @click="$emit('click')" class="notification-button">
    <img v-if="!withNotification" src="../../files/notification-icon.svg" alt="user notification" />
    <img v-else src="../../files/notification-icon_active.svg" alt="user notification" />
  </button>
</template>

<script>
export default {
  props: {
    withNotification: {
      type: Boolean,
      require: false,
    },
  },
};
</script>

<style scoped>
.notification-button {
  position: relative;
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  opacity: 1;
  transition: opacity 0.15s ease-out;
}
.notification-button:hover {
  opacity: 0.75;
}
</style>
